import React, { useState } from "react";
import Chemical from "./master/Chemical";
import MaterialTraceReports from "./master/MaterialTraceReports";
import "./StoreOperations.scss";

const STORE_OPERATIONS = {
  chemical: "chemical",
  material: "material",
};

const StoreOperations = () => {
  const [activeOperation, setActiveOperation] = useState(
    STORE_OPERATIONS.chemical,
  );
  const isChemical = activeOperation === STORE_OPERATIONS.chemical;

  return (
    <main className="store-operations main" id="main">
      <div className="store-operations__shell">
        <header className="store-operations__header">
          <div className="store-operations__header-icon" aria-hidden="true">
            <i className="bi bi-box-seam" />
          </div>
          <div>
            <h1>Store Operations</h1>
            <p>
              Manage consumables batches and wire trace numbers in one place.
            </p>
          </div>
        </header>

        <nav
          className="store-operations__tabs"
          aria-label="Store operations"
          role="tablist"
        >
          <button
            type="button"
            role="tab"
            aria-selected={isChemical}
            className={`store-operations__tab ${
              isChemical ? "store-operations__tab--active" : ""
            }`}
            onClick={() => setActiveOperation(STORE_OPERATIONS.chemical)}
          >
            <span className="store-operations__tab-icon" aria-hidden="true">
              <i className="bi bi-droplet-half" />
            </span>
            <span className="store-operations__tab-copy">
              <strong>Consumables Batches</strong>
              <small>Maintain consumables and batch details</small>
            </span>
            <i className="bi bi-chevron-right store-operations__tab-arrow" />
          </button>

          <button
            type="button"
            role="tab"
            aria-selected={!isChemical}
            className={`store-operations__tab ${
              !isChemical ? "store-operations__tab--active" : ""
            }`}
            onClick={() => setActiveOperation(STORE_OPERATIONS.material)}
          >
            <span className="store-operations__tab-icon" aria-hidden="true">
              <i className="bi bi-upc-scan" />
            </span>
            <span className="store-operations__tab-copy">
              <strong>Wire Trace Records</strong>
              <small>Assign and review wire trace numbers</small>
            </span>
            <i className="bi bi-chevron-right store-operations__tab-arrow" />
          </button>
        </nav>

        <section
          className="store-operations__content"
          role="tabpanel"
          aria-label={isChemical ? "Consumables Batches" : "Wire Trace Records"}
        >
          {isChemical ? <Chemical embedded /> : <MaterialTraceReports embedded />}
        </section>
      </div>
    </main>
  );
};

export default StoreOperations;
